/**
* @author Indeform Ltd
* @copyright Copyright 2020, Indeform Ltd
* @version 20200306
* @description Register status component.
*/


import Status from "../status";

class RegisterStatus extends Status {
    constructor(ui) {
        super(ui, 'formStatus', [], {
            elmForm: 'formRegister',
            elmStatusError: 'formStatusError',
            elmStatusCode: 'statusCode',
            elmTimer: 'timer',
        });
    }
}

export { RegisterStatus }
export default RegisterStatus